import { render, staticRenderFns } from "./guia.vue?vue&type=template&id=7d63b25f&scoped=true&"
import script from "./guia.vue?vue&type=script&lang=js&"
export * from "./guia.vue?vue&type=script&lang=js&"
import style0 from "./guia.vue?vue&type=style&index=0&id=7d63b25f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d63b25f",
  null
  
)

export default component.exports